import * as React from "react";
import PaymentPlanPage from "../pages/PaymentPlan";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../store";
import { agent } from "../agent";
import { myDataActions } from "../store/myData";
import { URL_PATHS } from "../routes";
import { useState } from "react";
import { Redirect, useHistory } from "react-router";
import { NewPayment, paymentActions } from "../../src/store/payment";
import {
    CardPaymentPlan,
    PaymentMethodEnum,
    PaymentPlanEnum
} from "../generated/UserAPIAgent";
import PaymentPlanDetailPage from "../pages/PaymentPlan/paymentPlanDetail";
import { PAYMENT_PLANS } from "../generated/lib-domain/paymentPlan";
import { PaymentType } from "../generated/lib-domain/paymentZeus";
import { smartAlert, smartConfirm } from "../lib/confirm-alert";

/**
 * @return ライトプランが先に来るように、cardPaymentPlansをソートする
 */
const planSort = (cardPaymentPlans: CardPaymentPlan[]): CardPaymentPlan[] => {
    if (cardPaymentPlans.length < 2) {
        return cardPaymentPlans;
    }
    return cardPaymentPlans.slice().sort((plan1, plan2) => {
        if (plan1.amount < plan2.amount) {
            return -1;
        }
        return 1;
    });
};

const PaymentPlanContainer = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [cardPaymentPlan, setCardPaymentPlan] =
        useState<CardPaymentPlan | null>(null);
    const payment = useSelector((state: AppState) => state.payment);
    const paymentStatus = useSelector(
        (state: AppState) => state.payment.status
    );
    const dispatch = useDispatch();
    const history = useHistory();
    /**
     * カード決済中でアップグレードするユーザーか否か判断
     */
    const isUpgradeCardPaymentUser = (newPayment: NewPayment): boolean => {
        return (
            payment.status.paymentType === PaymentType.Repeat &&
            payment.status.currentPaymentPlan?.id ===
                PaymentPlanEnum.LITE_1M_CARD_1000 &&
            newPayment.paymentPlanId === PaymentPlanEnum.STANDARD_1M_CARD_9800
        );
    };
    /**
     * クレジットカード情報が存在するか否か判断
     */
    const haveCreditCardInfo = (): boolean => {
        return (
            payment.status?.creditCardInfo?.cardExpiresMonth != null &&
            payment.status?.creditCardInfo?.cardExpiresYear != null &&
            payment.status?.creditCardInfo?.cardNumberSuffix != null
        );
    };
    async function onNavigateToPaymentMakePage() {
        const confirmed = await smartConfirm({
            message: `${
                PAYMENT_PLANS.find(
                    (plan) => plan.id === cardPaymentPlan.paymentPlanId
                ).title
            }を購入しますか？`
        });
        if (!confirmed) {
            return;
        }
        setIsLoading(true);
        const newPayment: NewPayment = {
            paymentPlanId: cardPaymentPlan.paymentPlanId,
            campaignId:
                cardPaymentPlan.campaigns.length > 0
                    ? cardPaymentPlan.campaigns[0].campaignId
                    : null,
            amount: cardPaymentPlan.amount,
            firstAmount:
                cardPaymentPlan.campaigns.length > 0
                    ? cardPaymentPlan.campaigns[0].firstAmount
                    : null
        };
        if (isUpgradeCardPaymentUser(newPayment) && haveCreditCardInfo()) {
            // カード決済中でアップグレードするユーザーの場合、
            // クレジットカードの入力は省略されるのでpaymentMakeに遷移しない
            try {
                await agent.postPaymentZeusSubscribe({
                    currentPaymentState: {
                        paymentType: payment.status.paymentType as PaymentType,
                        paymentPlanId: payment.status.currentPaymentPlan.id,
                        paymentMethod: payment.status
                            .primaryPaymentMethod as PaymentMethodEnum
                    },
                    newPayment: newPayment
                });
                dispatch(myDataActions.myDataShouldLoadSet(true));
                setIsLoading(false);
                history.push(URL_PATHS.subscriptionChangeFinish());
                return;
            } catch (e) {
                setIsLoading(false);
                await smartAlert("登録に失敗しました");
            }
        }
        dispatch(paymentActions.selectedPaymentSet(newPayment));
        dispatch(paymentActions.paymentInProgressSet(true));
        setIsLoading(false);
        history.push(URL_PATHS.paymentMake3DS());
    }
    const onNavigateToPaymentPlanDetailPage = (
        paymentPlanId: PaymentPlanEnum
    ) => {
        const cardPaymentPlan = payment.status.cardPaymentPlans.find(
            (plan) => plan.paymentPlanId === paymentPlanId
        );
        setCardPaymentPlan(cardPaymentPlan);
        return false;
    };
    const closePaymentDetailPage = (): void => {
        setCardPaymentPlan(null);
    };
    if (
        payment.status.currentPaymentPlan?.id ===
            PaymentPlanEnum.STANDARD_1M_CARD_9800 ||
        payment.status.cardPaymentTransitionApplicationDate !== null
    ) {
        // カード決済スタンダードプランに加入中のユーザーまたはカード決済切り替え待ちのユーザーの場合、
        // プランの変更導線を用意しないためリダイレクト
        return <Redirect to={URL_PATHS.paymentInfo()} />;
    }
    if (cardPaymentPlan) {
        return (
            <PaymentPlanDetailPage
                cardPaymentPlan={cardPaymentPlan}
                onNavigateToPaymentMake={onNavigateToPaymentMakePage}
                close={closePaymentDetailPage}
                isLoading={isLoading}
            />
        );
    }
    return (
        <PaymentPlanPage
            paymentStatus={paymentStatus}
            isLoading={isLoading}
            cardPaymentPlans={planSort(paymentStatus.cardPaymentPlans)}
            onNavigateToPaymentPlanDetail={onNavigateToPaymentPlanDetailPage}
        />
    );
};

export default PaymentPlanContainer;
